<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q88wi7/tc-custom/9781035808380.jpg?1718183000468" alt="This image is the cover for the book Cinnamon’s Autumn Adventure"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cinnamon’s Autumn Adventure
      </h1>
      <p class="bookDescription body article font2">
        <p>Cinnamon’s Autumn Adventure is a captivating glimpse of the natural countryside we live in, coupled with a range of activities to involve children and parents/carers. These activities have been chosen by an experienced early years teacher with many years’ experience working with young children and a strong sense of the pursuits that children enjoy doing. The book also cleverly introduces a counting element and aims to present a rich, vibrant vocabulary to very young children. The author wants to share her passion for the countryside, and a love of language and storytelling with children and adults everywhere.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sally McGuiness
      </h2>
      
      <p class="authorDescription body article">Born and brought up in North Cornwall, Sally and siblings spent many days outside. Nature and the environment are crucial to her happiness and well-being. Having qualified as an Early Years teacher, she moved to the Midlands to teach, whilst raising her own family. Being outdoors was an important part of their family dynamic. During her teaching career, Sally’s favourite part of the day was telling stories and watching the children’s faces as they escaped into imaginary worlds. Since retiring, Sally has been able to focus on writing and through her books hopes to take the readers on a delightful journey, where both adults and children can engage in unique activities together.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publisher
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?63d04466